import awsRestAPI from "../../../../../services/api/awsRestAPI";
import NetworkTest from "opentok-network-test-js";
import OT from "@opentok/client";
import { TEST_RESULT } from "../../../enums";
import { TEST_RESULT_MESSAGES } from "../../../const";

export default {
  async performConnectivityTest({ commit, dispatch }) {
    commit("setTestProgress", true);
    commit("setTestResultMessage", TEST_RESULT_MESSAGES.READY);
    let qualityResult;

    try {
      const videoChatResponse = await awsRestAPI.createVideoChat({ recipientUUID: null });

      const networkTest = new NetworkTest(OT, {
        apiKey: videoChatResponse.data.video_chat.apiKey,
        sessionId: videoChatResponse.data.video_chat.sessionId,
        token: videoChatResponse.data.video_chat.token
      });

      commit("setTestResult", TEST_RESULT.GOOD);

      const connectivityResult = await networkTest.testConnectivity();
      if (!connectivityResult.success) {
        // That means we can't connect to servers, no need to call other tests
        commit("setTestResult", TEST_RESULT.ERROR);
        commit("setTestResultMessage", TEST_RESULT_MESSAGES.ERROR);
        commit("setTestProgress", false);
        return;
      }

      qualityResult = await networkTest.testQuality();
    } catch (error) {
      commit("setTestResult", TEST_RESULT.ERROR);
      commit("setTestResultMessage", error.name);
      commit("setTestProgress", false);
      return;
    }

    dispatch("logConnectivityTestResult", qualityResult);

    commit("setTestResultData", qualityResult);
    commit("setTestProgress", false);
  },

  /**
   * Log connectivity test results
   * @param {Object} qualityResult
   * @return {Promise<void>}
   */
  async logConnectivityTestResult(_, qualityResult) {
    await awsRestAPI.setUserConnectivity({
      connectivity: qualityResult
    });
  }
};
